import { useMutation } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { patch } from "common/helpers/HTTP";

import { useCampaignContext } from "../context/CampaignContext";
import useUpdateCampaign from "./useUpdateCampaign";

import type { CampaignSchedule, DetailedCampaign } from "../types";

async function setScheduleRequest(
  workspaceId: string,
  campaignId: string,
  schedule: CampaignSchedule,
): Promise<DetailedCampaign> {
  return (
    await patch(`workspaces/${workspaceId}/campaigns/${campaignId}/schedule`, {
      ...schedule,
    })
  ).campaign;
}

export default function useCampaignSchedule() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { id: campaignId } = useCampaignContext();

  const { updateCachedCampaign } = useUpdateCampaign();

  const {
    mutateAsync: setCampaignSchedule,
    isPending: isSettingCampaignSchedule,
  } = useMutation({
    mutationFn: ({ schedule }: { schedule: CampaignSchedule }) =>
      setScheduleRequest(workspaceId, campaignId, schedule),
    onSuccess: ({ schedule }) => {
      updateCachedCampaign(campaignId, (draftCampaign) => {
        draftCampaign.schedule = schedule;
      });
    },
  });

  return { setCampaignSchedule, isSettingCampaignSchedule };
}
